// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__36kha","filesListContainer":"PosDisputesFiles_filesListContainer__3wX2e","filesButton":"PosDisputesFiles_filesButton__31vlt"};